import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

export const apiEmpresaService = {
  getById: async (idEmpresa) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPRESA.ONE(idEmpresa),
      { method: "GET" }
    );

    return response.json();
  },
  putById: async (idEmpresa, json) => {
    const response = await requestWithAuth(API_ENDPOINTS.EMPRESA.UPDATE(idEmpresa), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });
    if(response.status !== 200){
      throw new Error("ERROR")
    }
    return response.json();
  },
};
